import { OrganizationConnectedPlatform } from 'src/enums'
import {
  AttachmentVerification,
  ReceiptMatchingStatuses,
} from 'src/models/receiptVerification.models'
import { ConnectedPlatformStatus } from 'src/models/transaction.models'

interface ReceiptAttachmentUrlsResponse {
  main: string
  original: string
  thumb: string
}

export enum AttachmentUploadType {
  TRANSACTION = 'TRANSACTION',
  APP = 'APP',
  EMAIL = 'EMAIL',
  PHONE_MESSAGE = 'PHONE_MESSAGE',
}

export class ReceiptAttachmentUrlsModel {
  public main: string
  public original: string
  public thumb: string

  public constructor(data: ReceiptAttachmentUrlsResponse) {
    this.main = data.main
    this.original = data.original
    this.thumb = data.thumb
  }
}

export interface AttachmentConnectedPlatformListResponse {
  id: string
  organizationId: string
  receiptAttachmentId: string
  platform: OrganizationConnectedPlatform
  syncStatus: ConnectedPlatformStatus
}

export class AttachmentConnectedPlatformModel {
  public id: string
  public organizationId: string
  public receiptAttachmentId: string
  public platform: OrganizationConnectedPlatform
  public syncStatus: ConnectedPlatformStatus

  public constructor(data: AttachmentConnectedPlatformListResponse) {
    this.id = data.id
    this.organizationId = data.organizationId
    this.receiptAttachmentId = data.receiptAttachmentId
    this.platform = data.platform
    this.syncStatus = data.syncStatus
  }
}

export interface ReceiptAttachmentResponse {
  id: string
  transactionId?: string
  virtualCardId?: string
  contentType: string
  urls: ReceiptAttachmentUrlsResponse
  additionalProperties?: unknown
  createdAt: string
  updatedAt: string
  uploadType: AttachmentUploadType
  connectedPlatforms?: AttachmentConnectedPlatformListResponse[]
  matchingStatuses?: ReceiptMatchingStatuses
  verification?: AttachmentVerification
  expenseId?: string
}

export class ReceiptAttachmentModel {
  public id: string
  public transactionId?: string
  public virtualCardId?: string
  public contentType: string
  public urls: ReceiptAttachmentUrlsModel
  public additionalProperties?: unknown
  public createdAt: string
  public updatedAt: string
  public uploadType: AttachmentUploadType
  public connectedPlatforms?: AttachmentConnectedPlatformModel[]
  public matchingStatuses?: ReceiptMatchingStatuses
  public verification?: AttachmentVerification
  public expenseId?: string

  public constructor(data: ReceiptAttachmentResponse) {
    this.id = data.id
    this.transactionId = data.transactionId
    this.virtualCardId = data.virtualCardId
    this.contentType = data.contentType
    this.urls = new ReceiptAttachmentUrlsModel(data.urls)
    this.additionalProperties = data.additionalProperties
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
    this.uploadType = data.uploadType
    this.connectedPlatforms =
      data.connectedPlatforms !== undefined
        ? data.connectedPlatforms.map(
            (cp) => new AttachmentConnectedPlatformModel(cp),
          )
        : undefined
    this.matchingStatuses = data.matchingStatuses
    this.verification = data.verification
    this.expenseId = data.expenseId
  }
}
